import { actionKeyGenerate, ACTION, GenericObject } from "../../util/utils";

export const MODULE_KEY = "ECOM_ORDERS";

export const KEYS: GenericObject = actionKeyGenerate(MODULE_KEY);

export const ECOM_ORDERS_FETCH = KEYS[MODULE_KEY + ACTION.FETCH];

export const fetchEcomOrdersList = () => ({
  type: ECOM_ORDERS_FETCH,
});

export const fetchEcomOrdersListSuccess = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.SUCCESS],
  payload,
});

export const fetchEcomOrdersListFailed = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.FAILED],
  payload,
});

export const PROCESS_ECOM_ORDERS = "ECOM_ORDERS_PROCESS";

export const processEcomOrders = (payload: { ItemIds: number[], PickerId: number, TrackingNumber?: string, ShippingId?: number }) => ({
  type: PROCESS_ECOM_ORDERS,
  payload,
});

export const FETCH_ECOM_SHIPPING = "ECOM_SHIPPING_FETCH";
export const FETCH_ECOM_SHIPPING_SUCCESS = "ECOM_SHIPPING_FETCH_SUCCESS";
export const FETCH_ECOM_SHIPPING_FAILED = "ECOM_SHIPPING_FETCH_FAILED";

export const fetchEcomShipping = () => ({
  type: FETCH_ECOM_SHIPPING,
});

export const fetchEcomShippingSuccess = (payload: any) => ({
  type: FETCH_ECOM_SHIPPING_SUCCESS,
  payload,
});

export const fetchEcomShippingFailed = (payload: any) => ({
  type: FETCH_ECOM_SHIPPING_FAILED,
  payload,
});

export const SAVE_ECOM_SHIPPING = "ECOM_SHIPPING_SAVE";

export const saveEcomShipping = (payload: any) => ({
  type: SAVE_ECOM_SHIPPING,
  payload,
});

export const CANCEL_ECOM_ORDERS = "ECOM_ORDERS_CANCEL";

export const cancelEcomOrders = (payload: { ItemIds: number[] }) => ({
  type: CANCEL_ECOM_ORDERS,
  payload,
});
